import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { APP_CONFIG, AppConfig } from '../../../app-config';
import { ApiservicesService } from 'src/app/apiservices.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { formatDate } from '@angular/common';
import { UserTopComponent } from '../../../components/user-top/user-top.component';
import { EncryptdecryptService } from '../../../services/encryptdecrypt.service';
import { HttpClient } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { WindowFormService } from '../../../services/window-form.service';
import { NoticeDialogService } from 'src/app/components/shared/notice-dialog.service';

@Component({
  providers: [UserTopComponent],
  selector: 'app-e-borang',
  templateUrl: './e-borang.component.html',
  styleUrls: ['./e-borang.component.css'],

})
export class EBorangComponent implements OnInit {
  urlSafe: string = ""; // Initialize to an empty string
  trustedURL!: SafeResourceUrl;

  //UI Status Varibles
  SearchStatus: boolean = false;
  IsAdminStatus: boolean = false;
  YearAssessmentRegisterStatus: boolean = false;
  SearchByIDNoStatus: boolean = false;
  SearchByTINStatus: boolean = false;
  RegisterFormAccess: boolean = false;
  PindaanStatus: boolean = false;

  //SessionData
  SessionRoles: any = [];
  SessionIPAddress: any;

  //UI Data Variables
  SearchTypeInput: any = "";
  ValueInput: any = "";
  FormTypeInput: any = "";
  YearAssessmentInput: any = "";
  AgentInput: any = "";
  DistributeInput: any = "";
  CKMYearAssessmentInput: any = "";
  CP22YearAssessmentInput: any = "";

  //Data Variables
  IDNo: any = "";
  IDType: any = "";
  IT_REF_NO: any = "";
  OLD_IT_REF_NO: any = "";
  BranchName: any = "";
  Name: any = "";
  TaxAgentID = "";
  TaxAgentName = "";
  AgentList: any = new Array;
  FormTypeList: any[] = [];
  YearAssessmentList:any[] = [];

  //UI Agih Variables
  TaxpayerNameView: any = "";
  FormTypeView: any = "";
  StaffNameView: any = "";
  TaxpayerRefNumView: any = "";
  RegisterDateView: any = "";
  DistributeList: any;
  TaxReturnFormIDView: any = "";
  OldStaffID: any = "";
  TaxAgentIDView: any = "";

  //UI View Alert Variables
  AlertType: string = "";
  AlertStatus: boolean = false;
  AlertMessage: string = "";

  //Data Load Variables
  SearchTypeLoad: any = "";
  SearchInputLoad: any = "";

  //Reset Form Variable
  TaxRefNumResetForm: any = "";
  FormTypeResetForm: any = "";
  YearAssessmentResetForm: any = ""
  SubmitFormName: any = "";    ;

  //Session Variables
  SessionStaffIDNo: any = "";
  SessionFirmID: any = "";
  SessionStaffID: any = "";
  SessionRole: any = "";

  //Datatable Variables
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  dataSource = new MatTableDataSource();
  dataSourceOtherFirm = new MatTableDataSource();
  displayedColumns = ['jenisborang', 'staffname', 'agentname', 'tarikhdaftar', 'tarikhhantar', 'action'];
  displayedColumnsOtherFirm = ['jenisborang', 'tarikhdaftar'];
  LoaderStatus: boolean = false;

  // Config property for HTML access
  beLoginUrl: string = "";  // Inject AppConfig
  yearBeStartOauth: number = 2025;

  constructor(
    private router: Router,
    private apiServices: ApiservicesService, 
    private top: UserTopComponent, 
    private encryptDecryptService: EncryptdecryptService, 
    private http: HttpClient, 
    private sanitizer: DomSanitizer,
    @Inject(APP_CONFIG) private config: AppConfig,
    private windowForm: WindowFormService,
    private noticeDialog: NoticeDialogService            // <-- add service
  ) { 
    this.beLoginUrl = config.beLoginUrl;      
    this.yearBeStartOauth = config.YearBeStartOauth ?? 2025; // <-- load from app-config
  }

  ngOnInit(): void {
    this.SessionStaffIDNo = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffIDNo') || '');
    this.SessionFirmID = this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || '');
    this.SessionStaffID = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffID') || '');
    this.getIPAddress();
    this.top.updateTotal();
  }
  onChangeIDType() {
    this.ValueInput = "";
    this.ResetValue();
  }
  async Submit(searchType: any, ValueInput: any) {
    await this.ResetValue();
    this.LoaderStatus = true;
    if (this.CheckNull(searchType) || this.CheckNull(ValueInput)) {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.SearchStatus = false;
      this.LoaderStatus = false;
    } else if (searchType === '1' && isNaN(ValueInput)) {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan MyKad/MyPR/MyKAS yang tepat";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.SearchStatus = false;
      this.LoaderStatus = false;
    } else if (searchType === '6' && isNaN(ValueInput)) {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan TIN yang tepat";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.SearchStatus = false;
      this.LoaderStatus = false;
    } else if (searchType === '7' && isNaN(ValueInput)) {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan No. Majikan yang tepat";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.SearchStatus = false;
      this.LoaderStatus = false;
    } else {
      this.SearchTypeLoad = searchType;
      this.SearchInputLoad = ValueInput;
      await this.GetDetails(searchType, ValueInput);
      await this.GetAgent(this.SessionFirmID);
      this.LoaderStatus = false;
    }
  }
  async GetDetails(IDType: any, IDNo: any) {
    this.ResetValue();
    this.LoaderStatus = true;
    let Params = {};
    if (sessionStorage.getItem('TaxAgentID') === null)
    {
      if (IDType === "6")
      {
        Params = {
          "ITRefNo": IDNo,
          "FirmID": this.SessionFirmID,
          "StaffID": this.SessionStaffID
        };
      } else if (IDType === "7") {
        Params = {
          "newEmplRefNo": IDNo,
          "FirmID": this.SessionFirmID,
          "StaffID": this.SessionStaffID
        };
      } else {
        Params = {
          "IDNo": IDNo,
          "IDType": IDType,
          "FirmID": this.SessionFirmID,
          "StaffID": this.SessionStaffID
        };
      }
    } else {
      if (IDType === "6") {
        Params = {
          "ITRefNo": IDNo,
          "FirmID": this.SessionFirmID,
          "StaffID": this.SessionStaffID,
          "AgentID": this.encryptDecryptService.decrypt(sessionStorage.getItem('TaxAgentID') || '')
        };
      } else if (IDType === "7") {
        Params = {
          "newEmplRefNo": IDNo,
          "FirmID": this.SessionFirmID,
          "StaffID": this.SessionStaffID,
          "AgentID": this.encryptDecryptService.decrypt(sessionStorage.getItem('TaxAgentID') || '')
        };
      } else {
        Params = {
          "IDNo": IDNo,
          "IDType": IDType,
          "FirmID": this.SessionFirmID,
          "StaffID": this.SessionStaffID,
          "AgentID": this.encryptDecryptService.decrypt(sessionStorage.getItem('TaxAgentID') || '')
        };
      }
    }
    const result = await this.apiServices.GetListeBorang(Params);
    if (result.hasError) {
      this.LoaderStatus = false;
      this.AlertType = "fail";
      this.AlertMessage = result.errMsg;
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.SearchStatus = false;
    } else {
      if (result.taxPayer.jenisPengenalan === 1)
      {
        result.taxPayer.jenisPengenalan = "MyKad/MyPR/MyKAS";
      } else if (result.taxPayer.jenisPengenalan === 2) {
        result.taxPayer.jenisPengenalan = "No. Pasport/Dokumen lain";
      } else if (result.taxPayer.jenisPengenalan === 3) {
        result.taxPayer.jenisPengenalan = "Tentera";
      } else if (result.taxPayer.jenisPengenalan === 4) {
        result.taxPayer.jenisPengenalan = "Polis";
      }
      this.Name = result.taxPayer.nama;
      this.IDType = result.taxPayer.jenisPengenalan;
      this.IDNo = (result.taxPayer.noPengenalan === null || result.taxPayer.noPengenalan.replace(/\s/g, "") === "") ? "N/A" : result.taxPayer.noPengenalan;
      this.IT_REF_NO = result.taxPayer.itRefNo;
      this.OLD_IT_REF_NO = result.taxPayer.oldItRefNo;
      this.BranchName = result.taxPayer.branchName;
      this.TaxAgentID = result.taxAgentID === 0 || result.taxAgentID === null || result.taxAgentID === "" ? "" : result.taxAgentID;

      if (IDType === "6")
        this.SearchByTINStatus = true;
      else
        this.SearchByIDNoStatus = true;


      if (this.TaxAgentID === "" && IDType !== "6")
      {
        this.SearchByTINStatus = false;
        this.SearchByIDNoStatus = true;
      }
      else if (this.TaxAgentID !== "" && IDType !== "6") {
        this.SearchByTINStatus = true;
        this.SearchByIDNoStatus = true;
      }
      else if (this.TaxAgentID !== "" && IDType === "6") {
        this.SearchByTINStatus = true;
        this.SearchByIDNoStatus = true;
      }
      else {
        this.SearchByTINStatus = true;
        this.SearchByIDNoStatus = false;
      }

      // Change jenis_Borang dynamically
      const mapping: any = {
        PE: "BNT BE",
        PB: "BNT B"
      };

      this.TaxAgentName = result.taxAgentName;
      result.eBorangFirma.forEach((currentValue: any, index: any) => {
        result.eBorangFirma[index].dateRegister = formatDate(result.eBorangFirma[index].dateRegister, 'dd-MMM-yyyy h:mm:ss a', "en-US");
        result.eBorangFirma[index].dateSubmit = result.eBorangFirma[index].dateSubmit === null || result.eBorangFirma[index].dateSubmit === "" || result.eBorangFirma[index].dateSubmit === undefined ? "N/A" : formatDate(result.eBorangFirma[index].dateSubmit, 'dd-MMM-yyyy h:mm:ss a', "en-US");
      });

      // Create new property
      result.eBorangFirma.forEach((item: any) => {
        const parts = item.jenis_Borang.split(' ');

        const formCode = parts[0];      // PE
        const year = parts.slice(1).join(' '); // 2025

        item.nama_Borang = mapping[formCode]
          ? `${mapping[formCode]} ${year}`
          : item.jenis_Borang;
      });

      result.eBorangOthers.forEach((currentValue: any, index: any) => {
        result.eBorangOthers[index].dateRegister = formatDate(result.eBorangOthers[index].dateRegister, 'dd-MMM-yyyy h:mm:ss a', "en-US");
        result.eBorangOthers[index].dateSubmit = result.eBorangOthers[index].dateSubmit === null || result.eBorangOthers[index].dateSubmit === "" || result.eBorangOthers[index].dateSubmit === undefined ? "N/A" : formatDate(result.eBorangOthers[index].dateSubmit, 'dd-MMM-yyyy h:mm:ss a', "en-US");
      });

      // Create new property
      result.eBorangOthers.forEach((item: any) => {
        const parts = item.jenis_Borang.split(' ');

        const formCode = parts[0];      // PE
        const year = parts.slice(1).join(' '); // 2025

        item.nama_Borang = mapping[formCode]
          ? `${mapping[formCode]} ${year}`
          : item.jenis_Borang;
      });

      this.SessionRoles = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffRoles') || '');
      const Roles = JSON.parse(this.SessionRoles);
      Roles.forEach((currentValue: any, index: any) => {
        if (Roles[index] === "0201") {
        
          this.IsAdminStatus = true;
        }

        if ((Roles.length > 1) && currentValue === "0201")
          this.RegisterFormAccess = true;

        if ((Roles.length === 1) && (currentValue === "0201" || currentValue === "0203"))
          this.RegisterFormAccess = false;
        else
          this.RegisterFormAccess = true;

      });
      this.dataSource = new MatTableDataSource(result.eBorangFirma);
      this.dataSourceOtherFirm = new MatTableDataSource(result.eBorangOthers);
      result.eBorang.forEach((currentValue: any, index: any) =>
      {
        //if (currentValue.pindaan !== "" && currentValue.pindaan !== null) {
        //  this.AmendmentList.push(currentValue.pindaan);
        //}

        this.FormTypeList.push(result.eBorang[index]);
      
      });

      this.FormTypeList = result.eBorang.map((item: any) => ({
        ...item,
        formDisplayName: mapping[item.formName] || item.formName
      }));

      this.SearchStatus = true;
    }
  }
  async GetAgent(FirmID: any) {
    let Params = {
      "FirmID": FirmID,
      "Role": "0204",
      "NonExpiredTaxAgent": false
    }
    const result = await this.apiServices.GetFirmStaff(Params);
    this.AgentList = result;
  }
  Semula() {
    this.SearchStatus = false;
    this.SearchTypeInput = "";
    this.ValueInput = "";
    this.IDNo = "";
    this.IDType = "";
    this.IT_REF_NO = "";
    this.OLD_IT_REF_NO = "";
    this.BranchName = "";
    this.Name = "";

    this.YearAssessmentRegisterStatus = false;
    this.SearchByIDNoStatus = false;
    this.SearchByTINStatus = false;

    this.FormTypeList = [];
    this.YearAssessmentList = [];

    this.LoaderStatus = false;
    this.IsAdminStatus = false;
    this.dataSource = new MatTableDataSource();
    this.dataSourceOtherFirm = new MatTableDataSource();
  }
  CheckNull(value: string): boolean {
    if (value == null || value == "") {
      return true;
    } else {
      return false;
    }
  }
  ResetValue() {
    this.SearchStatus = false;
    this.FormTypeInput = "";
    this.YearAssessmentInput = "";
    this.CKMYearAssessmentInput = "";
    this.CP22YearAssessmentInput = "";
    this.AgentInput = "";
    this.IDNo = "";
    this.IDType = "";
    this.IT_REF_NO = "";
    this.OLD_IT_REF_NO = "";
    this.BranchName = "";
    this.Name = "";
    this.AlertType = "";
    this.AlertStatus = false;
    this.AlertMessage = "";

    this.FormTypeList = [];

    this.LoaderStatus = false;
    this.IsAdminStatus = false;
    this.YearAssessmentRegisterStatus = false;
    this.SearchByIDNoStatus = false;
    this.SearchByTINStatus = false;

    this.TaxRefNumResetForm = "";
    this.FormTypeResetForm = "";
    this.YearAssessmentResetForm = "";


    this.OldStaffID = "";
    //this.SupervisorList = StaffID;
    this.TaxpayerNameView = "";
    this.FormTypeView = "";
    this.StaffNameView = "";
    this.TaxpayerRefNumView = "";
    this.RegisterDateView = "";
    this.TaxAgentIDView = "";

    this.TaxAgentID = "";
    this.TaxAgentName = "";
    this.SubmitFormName = "";
  }
  async RegisterForm(FormType: any, YearAssessment: any, AgentID: any, ClientID: any) {
    this.LoaderStatus = true;
    if (FormType === "" || (YearAssessment === "" && (FormType !== "CKM" && FormType !== "CP22"))) {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else if (AgentID === "" && this.TaxAgentID === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {

      this.FormTypeList.forEach((currentValue: any, index: any) => {
        if (FormType === currentValue.formDisplayName) {
          this.SubmitFormName = currentValue.formName;
        }
      });

      AgentID = AgentID === "" ? this.TaxAgentID : AgentID;
      let Params = {
        "FormType": this.SubmitFormName.trimEnd(),
        "YearAssessment": YearAssessment === "" ? null : YearAssessment,
        "FirmID": Number(this.SessionFirmID),
        "TaxAgentID": Number(AgentID),
        "StaffID": Number(this.SessionStaffID),
        "ClientID": String(ClientID),
        "ModuleName": "Pembayar Cukai",
        "PageName": "e-Borang"
      }
      const result = await this.apiServices.RegisterForm(Params);
      if (result.hasError) {
        this.GetDetails(this.SearchTypeLoad, this.SearchInputLoad);
        this.GetAgent(this.SessionFirmID);
        this.AlertType = "fail";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
      } else {
        this.GetDetails(this.SearchTypeLoad, this.SearchInputLoad);
        this.GetAgent(this.SessionFirmID);
        this.AlertType = "success";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
      }
    }
  }
  Distribute(TaxReturnFormID: any, StaffID: any, TaxpayerName: any, FormType: any, AgentID: any, StaffName: any, TaxpayerRefNum: any, RegisterDate: any, FormName: any) {
    this.OldStaffID = StaffID;
    //this.SupervisorList = StaffID;
    this.TaxpayerNameView = TaxpayerName;
    this.FormTypeView = FormName;
    this.StaffNameView = StaffName;
    this.TaxpayerRefNumView = TaxpayerRefNum;
    this.RegisterDateView = RegisterDate;
    this.TaxAgentIDView = AgentID;
    this.TaxReturnFormIDView = TaxReturnFormID;
    this.GetStaff(TaxReturnFormID, this.SessionStaffID, this.SessionFirmID);
  }
  async GetStaff(TaxReturnFormID: any, StaffID: any, FirmID: any) {
    let Params = {};
    if (sessionStorage.getItem('TaxAgentID') === null) {
      Params = {
        "FirmID": FirmID,
        "TaxReturnFormID": TaxReturnFormID,
        "StaffID": StaffID
      }
    } else {
      Params = {
        "FirmID": FirmID,
        "TaxReturnFormID": TaxReturnFormID,
        "StaffID": StaffID,
        "TaxAgentID": this.encryptDecryptService.decrypt(sessionStorage.getItem('TaxAgentID') || '')
      }
    }
    const result = await this.apiServices.GetDistributeList(Params);
    if (result.length > 0) {
      result.forEach((currentValue: any, index: any) => {
        switch (result[index].staffRole) {
          case "0202":
            result[index].staffName = result[index].staffName + " - (Penyelia)";
            break;
          case "0203":
            result[index].staffName = result[index].staffName + " - (Staf)";
            break;
          case "0204":
            result[index].staffName = result[index].staffName + " - (Ejen Cukai)";
            break;
          default:
            result[index].staffName = result[index].staffName;
            break;
        }
      });
    }
    this.DistributeList = result;
    //this.StaffList = result.Ejen.Staff;
    //this.SupervisorList = result.Ejen.Penyelia;
  }
  async DistributeSubmit(TaxReturnFormID:any,StaffID: any, TaxAgentID: any, TaxRefNum: any, FormType: any) {
    this.LoaderStatus = true;
    if (StaffID === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila isi butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      let Params = {
        "StaffID": StaffID,
        "ActionStaffID": this.SessionStaffID,
        "FirmID": this.SessionFirmID,
        "TaxReturnFormID": TaxReturnFormID,
        "ModuleName": "Pembayar Cukai",
        "PageName": "e-Borang",
      }
      const result = await this.apiServices.DistributeForm(Params);
      if (result.hasError) {
        this.AlertType = "fail";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
      } else {
        this.GetDetails(this.SearchTypeLoad, this.SearchInputLoad);
        this.GetAgent(this.SessionFirmID);
        this.AlertType = "success";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
      }
    }
  }
  async LoginForm(TaxReturnFormID: any,FormTypeYear:any) {

    // if (FormTypeYear === 'BE 2025' || FormTypeYear === 'B 2025' || FormTypeYear === 'BT 2025' || FormTypeYear === 'M 2025' || FormTypeYear === 'MT 2025') {
    //   this.noticeDialog.blockButton();
    //   return;
    // }

    let shouldOpenWindow = true;
    this.LoaderStatus = true;
    let URL = "", EncUserName = "", EncUserIDNo = "", EncPassword="", EncTAIDNo="", EncTaxPayerItRefNo = "",EncYear="", YearAssessment="";
    let Params = {
      "firmID": Number(this.SessionFirmID),
      "staffID": Number(this.SessionStaffID),
      "taxReturnFormID": Number(TaxReturnFormID)
    };
    const result = await this.apiServices.FormLogin(Params);


    if (result.hasError)
    {
      this.GetDetails(this.SearchTypeLoad, this.SearchInputLoad);
      this.GetAgent(this.SessionFirmID);
      this.AlertType = "fail";
      this.AlertMessage = result.errMsg;
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    }
    else
    {
      if (FormTypeYear.includes("CP204")) {
        if (FormTypeYear.substring(0, FormTypeYear.indexOf("-")) == "CP204A")
          YearAssessment = FormTypeYear.substring(FormTypeYear.indexOf("-") + 1, FormTypeYear.lastIndexOf("-"));
        else
          YearAssessment = FormTypeYear.substring(FormTypeYear.lastIndexOf("-") + 1);
      } else {
        YearAssessment = FormTypeYear.substring(FormTypeYear.lastIndexOf(" ") + 1);
      }

      EncUserName = await this.EncryptDecryptText('201', this.SessionStaffIDNo);
      EncUserIDNo = await this.EncryptDecryptText('201', this.SessionStaffIDNo);
      EncPassword = await this.EncryptDecryptText('201', result.password);
      EncTAIDNo = await this.EncryptDecryptText('201', result.taxAgentICNo);
      EncYear = await this.EncryptDecryptText('201', result.taxAgentICNo);
      EncTaxPayerItRefNo = await this.EncryptDecryptText('201', this.IT_REF_NO);
      let tempRoles = "";
      const Roles = JSON.parse(this.SessionRoles);
      Roles.forEach((currentValue: any, index: any) => {
        if (currentValue === "0202")
          tempRoles = "PENYELIA";
        else if (currentValue === "0203")
          tempRoles = "STAF";
        else if (currentValue === "0204")
          tempRoles = "EJEN CUKAI";
      });
      switch (result.formType) {
        case "P":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=P" + "&Tahun_Taksiran=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2021)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=P&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=P";
          break;
        case "E":
          if (Number(YearAssessment) >= 2022)
            this.CreateCP8DForm(TaxReturnFormID, YearAssessment)

          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=E" + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2021)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=E&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=E";
          break;
        case "CP8D":
          const cp8dUrl: string = result.url;
          const urlObj = new window.URL(cp8dUrl);
          const token = sessionStorage.getItem('token');

          if (token) {
            urlObj.searchParams.set('signature', token);
          }

          URL = urlObj.toString();
          break;
        case "C":
          if (Number(YearAssessment) > 2025)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&Tahun_Taksiran=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2021)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType;
          break;
        case "C1":
          if (Number(YearAssessment) > 2025)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Tahun_Taksiran=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2020)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType;
          break;
        case "BNTC1":
          if (Number(YearAssessment) > 2020)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType;
          break;
        case "BNT C":
          if (Number(YearAssessment) > 2025)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&NoRujukan=" + EncTaxPayerItRefNo + "&Tahun_Taksiran=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2021)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&NoRujukan=" + EncTaxPayerItRefNo + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&NoRujukan=" + EncTaxPayerItRefNo;
          break;
        case "TF":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2019)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType;
          break;
        case "TP":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&Username=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&IDType=1&JenisBorang=" + await this.EncryptDecryptText('201', result.formType)  + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2019)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&Username=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&IDType=1&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&Username=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&IDType=1";
          break;
        case "TC":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment);
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "BNTTC":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment);
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "PT":
          if (Number(YearAssessment) > 2025)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&Username=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Tahun_Taksiran=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2021)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&Username=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&Username=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "BNTPT":
          if (Number(YearAssessment) > 2021)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&Username=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&Username=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "TA":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment);
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "BNTTA":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment);
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "TR":
          if (Number(YearAssessment) > 2025)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment);
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "BNTTR":
          URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "TJ":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&TahunTaksiran=" + await this.EncryptDecryptText('201', YearAssessment);
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "LE1":
          URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment);
          break;
        case "CP204":
        case "CP204B":
          URL = result.url + "?IPAddress=" + this.SessionIPAddress + "&TaxReturnFormID=" + TaxReturnFormID +
            "&UserName=" + EncUserName + "&Password=" + EncPassword + "&FirmID=" + this.SessionFirmID +
            "&Nama=" + encodeURI(result.taxAgentName) + "&ID=" + EncTAIDNo + "&CompanyRefNo=" + EncTaxPayerItRefNo + "&Jenis_File=" + result.taxPayerFileType +
            "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + result.formType + "&Roc_No=" + encodeURI(result.taxPayerROC) + "&Jawatan=" + tempRoles + "&CompanyName=" + encodeURI(result.taxPayerName) +
            "&LicenseNo=" + result.taxAgentLicenseNo + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment);
          break;
        case "CP204A":
          URL = result.url + "?IPAddress=" + this.SessionIPAddress + "&TaxReturnFormID=" + TaxReturnFormID +
            "&UserName=" + EncUserName + "&Password=" + EncPassword + "&FirmID=" + this.SessionFirmID +
            "&Nama=" + encodeURI(result.taxAgentName) + "&ID=" + EncTAIDNo + "&CompanyRefNo=" + EncTaxPayerItRefNo + "&Jenis_File=" + result.taxPayerFileType +
            "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + result.formType + "&Roc_No=" + encodeURI(result.taxPayerROC) + "&Jawatan=" + tempRoles + "&CompanyName=" + encodeURI(result.taxPayerName) +
            "&LicenseNo=" + result.taxAgentLicenseNo + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment) + "&Pindaan=" + result.pindaan;
          break;
        case "CPP":
        case "CPE":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2019)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "BNT CPP":
          let tempFormType = result.formType.replace(" ", "")
          URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', tempFormType) + "&language=en-US";
          break;
        case "CKM":
          URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&language=en-US";
          break;
        case "CP22":
          //URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=CP22&language=en-US";
          URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=CP22&language=en-US";
          break;    
        case "BE":         
        case "B":
        case "BT":
        case "M":
        case "MT":
          if (Number(YearAssessment) >= this.yearBeStartOauth) { // <-- use config value
            //this.windowForm.openPostForm(this.beLoginUrl, {   // <-- use service
            this.windowForm.openPostForm(result.url, {
              auth_type: "digicert",
              form_tin: this.IT_REF_NO,
              form_type: result.formType,
              form_year: YearAssessment,
              cert_type: 2,
              TaxReturnFormID: TaxReturnFormID,
              language: "en-US",
            });                                                                                                                                 
            shouldOpenWindow = false;
          }
          else {
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&ID=" + EncUserIDNo + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + result.formType + "&TaxReferenceNo=" + result.firmTaxRefNum;
          }
          break;
        case "PE":
        case "PB":
          this.windowForm.openPostForm(result.url, {
            auth_type: "digicert",
            form_tin: this.IT_REF_NO,
            form_type: result.formType,
            form_year: YearAssessment,
            cert_type: 2,
            TaxReturnFormID: TaxReturnFormID,
            language: "en-US",
          });
          shouldOpenWindow = false;
          break;
          
        default: // IND
          URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&ID=" + EncUserIDNo + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + result.formType + "&TaxReferenceNo=" + result.firmTaxRefNum;
          break;
      }

      if (shouldOpenWindow && URL) {
        this.windowForm.openWindow(URL);                  // <-- use service
      }

      //window.open(URL, "_blank");
      this.GetDetails(this.SearchTypeLoad, this.SearchInputLoad);
      this.GetAgent(this.SessionFirmID);
      this.LoaderStatus = false;
    }
  }
  async EncryptDecryptText(Type: any, Text: any) {
    let EncryptedText;
    const result = await this.apiServices.GetEncryptDecrypt(Type, Text);
    EncryptedText = JSON.parse(JSON.stringify(result));
    return EncryptedText;
  }
  ResetFormValue(TaxRefNum: any, FormType: any, YearAssessment: any) {
    this.TaxRefNumResetForm = TaxRefNum;
    this.FormTypeResetForm = FormType;
    this.YearAssessmentResetForm = YearAssessment;
  }
  async ResetForm(TaxRefNum: any, FormType: any, YearAssessment: any) {
    this.LoaderStatus = true;


    //asad tambah checking reset cp8d tidak dibenarkan
    if (FormType == "CP8D" || FormType == "CP8D 2023")
    {
      this.AlertType = "fail";
      this.AlertMessage = "Tindakan set semula tidak dapat dilakukan bagi jenis borang e-CP8D.";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    }
    else {
      let Params = {
        "ClientID": String(TaxRefNum),
        "FormType": FormType,
        "YearAssessment": YearAssessment,
        "FirmID": Number(this.SessionFirmID),
        "StaffID": Number(this.SessionStaffID),
        "ModuleName": "Pembayar Cukai",
        "PageName": "e-Borang",
      }

      const result = await this.apiServices.ResetForm(Params);
      if (result.hasError) {
        this.AlertType = "fail";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
      } else {
        this.GetDetails(this.SearchTypeLoad, this.SearchInputLoad);
        this.GetAgent(this.SessionFirmID);
        this.AlertType = "success";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
      }
    }
  
  }
  async GetAcknowledment(FormType: any, YearAssessment: any, TaxRefNum: any) {

    // if (FormType === 'BE 2025' || FormType === 'B 2025' || FormType === 'BT 2025' || FormType === 'M 2025' || FormType === 'MT 2025') {
    //   this.noticeDialog.blockButton();
    //   return;
    // }

    this.LoaderStatus = true;
    let AmendmentCP204A = "";
    if (FormType.includes("CP204A")) {
      AmendmentCP204A = FormType.substring(FormType.lastIndexOf("-") + 1);
      FormType = FormType.substring(0, FormType.indexOf("-"));
    } else if (FormType.includes("CP204")) {
      FormType = FormType.slice(0, 5);
    } else if (FormType.includes("CP204B")) {
      FormType = FormType.slice(0, 6);
    } else if (FormType.includes("C1")) {
      FormType = FormType.slice(0, 2);
    } else if (FormType.includes("LE1")) {
      FormType = FormType.slice(0, 3);
    } else if (FormType.includes("CP22")) {
      FormType = FormType;
    } else {
      FormType = FormType.replace(/[0-9]/g, '').trim();
    }

    const result = await this.apiServices.GetAcknowledment(this.SessionFirmID, FormType, YearAssessment, TaxRefNum, AmendmentCP204A, this.SessionStaffIDNo);
    
    if (result.hasError) {
      this.AlertType = "fail";
      this.AlertMessage = result.errMsg;
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      this.LoaderStatus = false;
      this.GoAcknowledgment(result.url, result.paramBody);
    }
  }
  GoAcknowledgment(ParamUrl: any, ParamBody: any) {
    
    const existingForm = document.getElementById("semakan-post-form");
    if (existingForm) {
      existingForm.remove();
    }
    
    const form = document.createElement("form");
    form.id = "semakan-post-form";
    form.target = "Map";
    form.method = "POST";
    form.action = ParamUrl;

    for (let x = 0; x < ParamBody.length; x++) {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = ParamBody[x].paramName;
      input.value = ParamBody[x].paramValue;
      form.appendChild(input);
    }

    document.body.appendChild(form);

    const map = window.open("", "Map");

    if (map) {
      this.LoaderStatus = false;
      form.submit();
    } else {
      alert("You must allow popups for this map to work.");
    }
  }
  ChangeFormTypeRegister(FormType: any)
  {
    this.YearAssessmentList = [];
    this.FormTypeList.forEach((currentValue: any, index: any) =>
    {
      if (FormType === currentValue.formDisplayName)
      {
        currentValue.formYear.forEach((currentValueInner: any, indexInner: any) => {
          this.YearAssessmentList.push(currentValueInner);
        });
        
      }
    });
    this.YearAssessmentList.sort(function (a, b) {
      return b - a; // sort in descending order
    })
    //this.YearAssessmentList = this.YearAssessmentList.sort((a, b) => (a.nome > b.nome ? -1 : 1));
    this.YearAssessmentRegisterStatus = FormType === "CKM" || FormType === "CP22" ? false : true;
  }
  getIPAddress() {
    this.http.get<any>('https://geolocation-db.com/json/')
      .pipe(
        catchError(err => {
          return throwError(err);
        }),
        tap(response => {
          this.SessionIPAddress = response.IPv4;
        })
      )
  }
  //kena tambah untuk prod
  async CreateCP8DForm(TaxReturnFormID: any, FormYear:any) {
    //call api create cp8d
  
    let Params = {
      "taxReturnFormID": TaxReturnFormID,
      "formYear": FormYear
    }
    const result = await this.apiServices.CreateCP8D(Params);

  }
  
}

